import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("KeypressTerminal", "ExpressionTerminal", {
    defaults: {
      terminal: "pressed",
      value: ''
    },

    type: function() {
      return 'Keypress';
    },

    text: function() {
      return "pressed[" + this.get("value") + "]";
    }
  });
});
